<template>
  <div :class="{ 'modal': true, 'modal--active': isActive }">
    <div class="modal__backdrop" @click="closeModal()"></div>

    <div class="modal__content">
      <i class="modal__close" @click="closeModal()"></i>

      <iframe :src="`https://player.vimeo.com/video/${videoURL}?autoplay=1`" width="640" height="269" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: ["isActive", "videoURL"],
  methods: {
    closeModal() {
      this.$emit("closeModal");
    }
  }
};
</script>
